import { useState } from "react";

import {
    buildScheduledNotificationUpdate,
    getScheduledNotificationId,
    toDateTimeLocalInputValue,
} from "../scheduledNotificationsUtils";

function useScheduledNotificationEditor({ getRecipientOptions, loadScheduledNotifications, socket }) {
    const [editingNotificationId, setEditingNotificationId] = useState(null);
    const [editTitle, setEditTitle] = useState('');
    const [editBody, setEditBody] = useState('');
    const [editScheduledDateTime, setEditScheduledDateTime] = useState('');
    const [editRecipients, setEditRecipients] = useState([]);
    const [saveStatus, setSaveStatus] = useState({});

    const startEditing = notification => {
        const notificationId = getScheduledNotificationId(notification);

        setEditingNotificationId(notificationId);
        setEditTitle(notification.message?.title || '');
        setEditBody(notification.message?.body || '');
        setEditScheduledDateTime(toDateTimeLocalInputValue(notification.scheduledTime));
        setEditRecipients(getRecipientOptions(notification));
        setSaveStatus(prev => ({ ...prev, [notificationId]: null }));
    };

    const cancelEditing = () => {
        setEditingNotificationId(null);
        setEditTitle('');
        setEditBody('');
        setEditScheduledDateTime('');
        setEditRecipients([]);
    };

    const saveEditing = notification => {
        const notificationId = getScheduledNotificationId(notification);

        let payload;
        try {
            payload = buildScheduledNotificationUpdate({
                notification,
                title: editTitle,
                body: editBody,
                scheduledDateTime: editScheduledDateTime,
                recipients: editRecipients,
            });
        } catch (error) {
            setSaveStatus(prev => ({ ...prev, [notificationId]: { type: 'error', message: error.message } }));
            return;
        }

        setSaveStatus(prev => ({ ...prev, [notificationId]: { type: 'pending', message: 'Guardant...' } }));

        socket.emit(
            '.update_scheduled_notification',
            payload.scheduledTime,
            payload.message,
            payload.userIds,
            response => {
                if (response?.success) {
                    setSaveStatus(prev => ({ ...prev, [notificationId]: { type: 'success', message: 'Desada' } }));
                    cancelEditing();
                    loadScheduledNotifications();
                } else {
                    setSaveStatus(prev => ({
                        ...prev,
                        [notificationId]: {
                            type: 'error',
                            message: response?.error || 'No s\'ha pogut desar la notificació.',
                        },
                    }));
                }
            }
        );
    };

    return {
        cancelEditing,
        editState: {
            body: editBody,
            recipients: editRecipients,
            scheduledDateTime: editScheduledDateTime,
            setBody: setEditBody,
            setRecipients: setEditRecipients,
            setScheduledDateTime: setEditScheduledDateTime,
            setTitle: setEditTitle,
            title: editTitle,
        },
        editingNotificationId,
        saveEditing,
        saveStatus,
        startEditing,
    };
}

export default useScheduledNotificationEditor;
